import { render, staticRenderFns } from "./JustificativaCartao.vue?vue&type=template&id=4af56918&scoped=true"
import script from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JustificativaCartao.vue?vue&type=style&index=0&id=4af56918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af56918",
  null
  
)

export default component.exports